import { render } from "./ParentFilter.vue?vue&type=template&id=230aa719"
import script from "./ParentFilter.vue?vue&type=script&lang=js"
export * from "./ParentFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__